import { JourneyMap } from '@fullstory/proto/fs/api/metrics/pagemetrics';
import { ComputeJourneyMapRequest } from '@fullstory/proto/fs/services/alexa';
import { isEqual } from 'lodash';
import { JourneyComputationRequestBody } from './types';
import jstz from 'jstz';

export const journeyMapSimilarData = (
  oldData: JourneyMap | null,
  newData: JourneyMap | null,
): boolean => {
  if (!oldData || !newData) return false;
  return isEqual(oldData, newData);
};

export const journeyMapRequestBodyToComputeJourneyMapRequest = (
  body: JourneyComputationRequestBody,
): ComputeJourneyMapRequest => ({
  orgId: body.orgId,
  computation: body.computation,
  now: null, // current time is implied
  timezone: jstz.determine().name(),
  cacheOptions: body.cacheOptions ?? null,
  sampleOptions: body.sampleOptions ?? null,
});
